import * as React from 'react';
import css from './ExploreCardContainer.module.scss';

interface Props extends React.HTMLProps<{}> {}

class ExploreCardContainer extends React.PureComponent<Props> {
  public render() {
    return (
      <div className={css.ExploreCardContainer}>
        {this.props.children &&
          Array.isArray(this.props.children) &&
          this.props.children.map((child, i) => (
            <div className={css.ExploreCardContainer__Child} key={i}>
              {child}
            </div>
          ))}
      </div>
    );
  }
}

export default ExploreCardContainer;
